// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export const LOCKFILE_LINT_JSON_FILENAME: 'lockfile-lint.json' = 'lockfile-lint.json';

export const LOCKFILE_EXPLORER_FOLDERNAME: 'lockfile-explorer' = 'lockfile-explorer';
